import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyBtn", "yearlyBtn", "price", "period", "billingNote", "savingsNote"]

  connect() {
    this.interval = 'monthly'
  }

  selectMonthly() {
    this.interval = 'monthly'
    this.updateDisplay()
  }

  selectYearly() {
    this.interval = 'yearly'
    this.updateDisplay()
  }

  updateDisplay() {
    const isYearly = this.interval === 'yearly'

    // Update button styles
    if (this.hasMonthlyBtnTarget && this.hasYearlyBtnTarget) {
      if (isYearly) {
        this.monthlyBtnTarget.classList.remove('bg-purple-500', 'text-white')
        this.monthlyBtnTarget.classList.add('text-zinc-400', 'hover:text-white')
        this.yearlyBtnTarget.classList.remove('text-zinc-400', 'hover:text-white')
        this.yearlyBtnTarget.classList.add('bg-purple-500', 'text-white')
      } else {
        this.monthlyBtnTarget.classList.add('bg-purple-500', 'text-white')
        this.monthlyBtnTarget.classList.remove('text-zinc-400', 'hover:text-white')
        this.yearlyBtnTarget.classList.add('text-zinc-400', 'hover:text-white')
        this.yearlyBtnTarget.classList.remove('bg-purple-500', 'text-white')
      }
    }

    // Update price display
    if (this.hasPriceTarget) {
      this.priceTarget.textContent = isYearly ? '$99.99' : '$9.99'
    }

    if (this.hasPeriodTarget) {
      this.periodTarget.textContent = isYearly ? '/year' : '/month'
    }

    if (this.hasBillingNoteTarget) {
      this.billingNoteTarget.textContent = isYearly
        ? 'Billed yearly. Cancel anytime.'
        : 'Billed monthly. Cancel anytime.'
    }

    if (this.hasSavingsNoteTarget) {
      if (isYearly) {
        this.savingsNoteTarget.classList.remove('hidden')
      } else {
        this.savingsNoteTarget.classList.add('hidden')
      }
    }
  }
}
